<template>
    <vProjectHeader
        logoColor="timer"
        :categories="categories"
        :actions="dotsMenuActions"
        :project="timer"
        :shareLinks="shareLinks"
        :hasChanges="hasChanges"
        :hasSnapshot="hasSnapshot"
        :hidePublish="isCreatorShown"
        :hideShare="isCreatorShown"
        @publish="$emit('publish')"
    >
        <ButtonSecondaryMd
            v-if="isPublished(timer) && !hasChanges"
            @click="$emit('publish')"
            class="!px-2.5 !2xl:px-2.5"
        >
            <CodeIcon />
            <span class="hidden 2xl:block"> {{ $t("shared.copy_embed") }}</span>
        </ButtonSecondaryMd>
    </vProjectHeader>
</template>

<script>
import { TimerIcon, CodeIcon } from "@easy/ui/icons";
import { ButtonSecondaryMd } from "@easy/ui/buttons";
import { TIMER_ROUTE_NAMES } from "@/apps/timer/timer.routes";
import { mapActions, mapState, mapGetters } from "vuex";
import vProjectHeader from "@/shared/views/vProjectHeader.vue";
import { useTimerCreatorStore } from "@/apps/timer/project/onboarding/timer-creator.store";
import { storeToRefs } from "pinia";

export default {
    name: "TimerProjectHeader",
    components: {
        vProjectHeader,
        CodeIcon,
        ButtonSecondaryMd,
    },
    props: {
        actions: {
            type: Array,
            default: () => [],
        },
        shareLinks: {
            type: Array,
            default: () => [],
        },
    },
    emits: ["publish"],
    setup() {
        const timerCreatorStore = useTimerCreatorStore();
        const { isCreatorShown } = storeToRefs(timerCreatorStore);
        return { isCreatorShown };
    },
    computed: {
        ...mapState(["globalUrl"]),
        ...mapState("timer", ["timer", "hasChanges", "hasSnapshot"]),
        ...mapGetters(["isPublished"]),
        dotsMenuActions() {
            return this.isCreatorShown ? [] : this.actions;
        },
        categories() {
            if (this.isCreatorShown) {
                return [
                    {
                        label: this.$t("shared.creator.create_new"),
                        name: "page",
                        icon: TimerIcon,
                    },
                ];
            }
            return [
                {
                    label: this.$t("timer.menu.settings"),
                    name: TIMER_ROUTE_NAMES.projectSettings,
                    icon: TimerIcon,
                    handler: () => this.routeTo(TIMER_ROUTE_NAMES.projectSettings),
                },
            ];
        },
    },
    methods: {
        ...mapActions("timer", ["publishProject"]),
        routeTo(name, forcedView) {
            const { query } = this.$route;
            this.$router.push({ name, query: forcedView ? { ...query, view: forcedView } : query });
        },
    },
};
</script>
